<template>
  <div class="no-product-selected" >
    <h3>
      No Product Selected
    </h3>
  </div>
</template>

<script>
export default {
  name: 'NoProductSelected'
}
</script>

<style lang="scss" scoped >
.no-product-selected {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  h3 {
    font-size: var(--text-2xl);
    font-weight: 500;
  }
}
</style>
